import React, { Component } from 'react';
import './UserDetails.css'
import axios from 'axios'
import Axios from '../../Axios'
import { ToastContainer, toast } from 'react-toastify'
import { Urls } from '../../Urls'
import formImage from './res/images/form.png'
import userLoaderGIF from './res/images/userLoader.gif'
import { logActivity } from '../Utilities';
class UserDetails extends Component {

    constructor(props) {
        super(props)

        this.state = {
            userid: '',
            email: '',
            name: '',
            company: "",
            sector: "",
            country: "",
            currency: "",
            transportation: "",
            data_cycle: "AD",
            data_type: "Primary",
            cargo_type: "Reefer",
            date: "01",
            month: "01",
            year: "2019",
            volume_present: "yes",
            rate_present: "yes",
            spend_present: "yes",
            comment: "",
            userLoader: false
        }
    }

    componentDidMount() {
        // logActivity([
        //     {
        //         "screen": "Home",
        //         "module": "Metadata Page",
        //         "user_activity": "page viewed",
        //         "timestamp": new Date().toISOString()
        //     }
        // ])
        document.title = "DC | User Details"
        localStorage.removeItem('review_id')
        if (window.localStorage.getItem("admin_review_id")) {
            window.localStorage.removeItem("admin_review_id")
        }
        Axios.post(Urls.getUser)
            .then(res => {
                // console.log(res)
                this.setState({
                    userid: res.data[0].email,
                    email: res.data[0].email,
                    name: res.data[0].name
                })
                localStorage.setItem('userid', res.data[0].email)
                sessionStorage.setItem('role', res.data[0].role)
                if (res.data[0].role === 'admin') {
                    setTimeout(function () {
                        // console.log('Wating')
                    }, 5000);
                    // console.log('Admin logged in')
                    if (!sessionStorage.getItem('entry')) {
                        // console.log('Entry logged in')
                        this.props.history.push({
                            pathname: '/summaryScreen'
                        })
                        sessionStorage.setItem('entry', 1)
                    }
                    else {
                        this.props.history.push({
                            pathname: '/user_details'
                        })
                    }
                }


            })
            .catch(error => {
                console.log(error)
                toast.error('Failed while retrieving user details')
            })

    }

    changeHandler = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    submitHandler = (event) => {
        event.preventDefault()
        // validation of form fields
        if (this.state.company === "" && this.state.transportation === "" && this.state.data_type === "" && this.state.year === "") {
            document.getElementById("company").style.border = "1px solid red"
            document.getElementById("trans").style.border = "1px solid red"
            document.getElementById("data_type").style.border = "1px solid red"
            document.getElementById("year").style.border = "1px solid red"
        }
        else if (this.state.company === "") {
            document.getElementById("company").style.border = "1px solid red"
            document.getElementById("trans").style.border = "none"
            document.getElementById("data_type").style.border = "1px solid red"
            document.getElementById("year").style.border = "1px solid red"
        }
        else if (this.state.transportation === "") {
            document.getElementById("trans").style.border = "1px solid red"
        }
        else if (this.state.data_type === "") {
            document.getElementById("data_type").style.border = "1px solid red"
        }
        else if (this.state.year === "") {
            document.getElementById("year").style.border = "1px solid red"
        }
        else {
            // logActivity([
            //     {
            //         'screen': 'Home',
            //         'module': 'Metadata',
            //         'user_activity': 'metadata submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            var data = this.state
            delete data['userLoader']
            // console.log(data)
            this.setState({
                userLoader: true
            }, () =>
                Axios.post(Urls.upload_metadata, data)
                    .then(response => {
                        window.localStorage.setItem("userid", this.state.userid)
                        if(response && response.data && response.data.dataset_id){
                            const formattedDatasetID = response.data.dataset_id.replace(/ /g, '_');
                            window.localStorage.setItem("dataset_id", formattedDatasetID)
                        }
                        this.setState({ userLoader: false })
                        // console.log(response)
                        if (response.data.status === "exist") {
                            alert(`Dataset id: ${response.data.dataset_id}, is already in our database. Kindly add suffix for version number after company name.`)
                        }
                        else {
                            sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                            toast.success("Metadata Submitted", this.props.history.push({ pathname: "/file_upload" }))
                        }
                    })
                    .catch(error => {
                        this.setState({ userLoader: false })
                        toast.error("Metadata submission failed")
                        this.props.history.push({
                            pathname: "/user_details"
                        })
                        console.log(error)
                    }))
        }
    }

    // Go to Summary Screen
    goToSummary = () => {
        this.props.history.push({ pathname: "/summaryScreen" })
    }

    volumeChangeHandler = (event) => {
        this.setState({
            volume_present: event.target.value
        })
    }

    rateChangeHandler = (event) => {
        this.setState({
            rate_present: event.target.value
        })
    }

    spendChangeHandler = (event) => {
        this.setState({
            spend_present: event.target.value
        })
    }


    render() {
        var i;
        var year = []
        for (i = 2025 ; i >= 2005 ; i--) {
            year.push(i)
        }
        var dates = []
        for (i = 1; i <= 31; i++) {
            dates.push(i)
        }

        const sectors = ['FMCD', 'FMCG', 'CEMENT', 'AUTOMOBILE', 'STEEL', 'BREWING', 'BUILDING MATERIAL', , 'AGRICULTURAL', 'CEREMICS',
            'CHEMICAL', 'CONSTRUCTION', 'ECOMMERCE', 'ELECTRICALS', 'ELECTRONICS', 'ENGINEERING SERVICES', 'FASHION & CLOTHING', 'GLASS', 'HEALTHCARE',
            'INDUSTRIAL AUTOMATION', 'INFRASTRUCTURE', 'LOGISTICS', 'LUGGAGE', 'MANUFACTURING', 'MANUFACTURING EXCUTION SYSTEM', 'METALS & MINING',
            'OIL & GAS', 'PACKAGING', 'PAINTS', 'PAPER', 'PHARMCEUTICALS', 'PLASTICS', 'PRINTING & MINTING', 'RAW MATERIAL', 'TECHNOLOGY', 'TELECOM',
            'TEXTILE', 'TYRE']
        return (
            <div style={{ overflowY: 'hidden' }}>

                {/* Old Template code start here 
                <div className="container-contact100">
                    <ToastContainer />
                    <div className="wrap-contact100">
                        <div className="detail-form">
                            <form className="contact100-form validate-form" onSubmit={this.submitHandler}>
                                <span className="contact100-form-title">
                                    Fill detail form
                                </span>

                                <label className="label-input100" for="first-name">Tell us your name</label>
                                <div className="wrap-input100 rs1-wrap-input100" data-validate="Type first name">
                                    <input id="first-name" className="input100" type="text" name="name" placeholder="Name" value={this.state.name} onChange={this.changeHandler} />
                                    <span className="focus-input100"></span>
                                </div>

                                <label className="label-input100" for="email">Enter your email</label>
                                <div className="wrap-input100" data-validate="Valid email is required: ex@abc.xyz">
                                    <input id="email" className="input100" type="text" name="email" placeholder="Eg. example@email.com" value={this.state.email} onChange={this.changeHandler} />
                                    <span className="focus-input100"></span>
                                </div>

                                <label className="label-input100" for="phone" id='star'>Company Name</label>
                                <div className="wrap-input100 validate-input" data-validate="Type Client name">
                                    <input required id="company" className="input100" type="text" name="company" placeholder="Eg. xyz pvt ltd" required value={this.state.company} onChange={this.changeHandler} />
                                    <span className="focus-input100"></span>
                                </div>

                                <label className="label-input100" for="phone" id='star'>Sector</label>
                                <div className="wrap-input100 validate-input" data-validate="TSelect Sector">
                                    <select id="sector" className="select100" data-live-search="true"
                                        name="sector" required="true" onChange={this.changeHandler}>
                                        <option disabled selected value> -- select -- </option>
                                        {
                                            sectors.map(s => <option value={s}> {s} </option>)
                                        }

                                    </select><br></br>
                                </div>

                                <label className="label-input100" for="message" id='star'>Mode of Transportation</label>
                                <div className="wrap-input100 validate-input" data-validate="Enter Mode of Transportation">
                                    <select id="trans" className="select100" data-live-search="true"
                                        name="transportation" required="true" onChange={this.changeHandler}>
                                        <option disabled selected value> -- select -- </option>
                                        <option value="01"> Road </option>
                                        <option value="02"> Rail </option>
                                        <option value="03"> Sea </option>
                                        <option value="04"> Multi-modal </option>
                                    </select>
                                </div>

                                <label className="label-input100" for="message" id='star'>Type of Data</label>
                                <div className="wrap-input100 validate-input" data-validate="Enter Mode of Transportation">
                                    <select required id="data_type" className="select100" data-live-search="true"
                                        name="data_type" required onChange={this.changeHandler}>
                                        <option disabled selected value> -- select -- </option>
                                        <option value="AD"> Annual </option>
                                        <option value="HD"> Half yearly </option>
                                        <option value="QD"> Quarterly </option>
                                        <option value="MD"> Monthly </option>
                                        <option value="DD"> Daily Dispatch </option>
                                    </select>
                                </div>

                                <label className="label-input100" for="message" id='star'>Date</label>
                                <div className="wrap-input100 validate-input" data-validate="Enter Mode of Transportation">
                                    <select id="date" className="select100" data-live-search="true"
                                        name="date" required="true" onChange={this.changeHandler}>
                                        <option disabled selected value> -- select -- </option>
                                        {
                                            dates.map(d => <option value={d}> {d} </option>)
                                        }

                                    </select><br></br>
                                </div>

                                <label className="label-input100" for="message" id='star'>Month</label>
                                <div className="wrap-input100 validate-input" data-validate="Enter Mode of Transportation">
                                    <select id="month" className="select100" data-live-search="true"
                                        name="month" required="true" onChange={this.changeHandler}>
                                        <option disabled selected value> -- select -- </option>
                                        {
                                            months.map(m => <option value={m}> {m} </option>)
                                        }

                                    </select><br></br>
                                </div>

                                <label className="label-input100" for="message" id='star'>Financial Year</label>
                                <div className="wrap-input100 validate-input" data-validate="Enter Mode of Transportation">
                                    <select id="year" className="select100" data-live-search="true"
                                        name="year" required="true" onChange={this.changeHandler}>
                                        <option disabled selected value> -- select -- </option>
                                        {
                                            year.map(y => <option value={y}> {y} </option>)
                                        }

                                    </select><br></br>
                                </div>

                                <div className="container-contact100-form-btn">
                                    <button className="contact100-form-btn" type="submit">Submit</button>
                                </div>

                                <div className="select_old">
                                    <p>
                                        <b> If you already cleaned your dataset: </b>
                                        <a style={{ "cursor": "pointer", "color": "red" }} onClick={this.goToSummary}> Click here! </a>
                                    </p>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

                <div className="contact100-more flex-col-c-m" style={{ 'background-image': "url('static/css/images/images(3).jpg')" }}>
                    <div id="nav-bar">
                        <img src="static/css/images/logo.png" alt="header_img" width="100" height="50" style={{ position: "absolute", top: "0%", left: "0%" }} />
                        <h1 className="app_name">Data Cleaning Application</h1>
                    </div>
                    <p className="app_intro">Data Cleaning Application is web-based application.
                        It cleans your “Location, Transporter and Truck Type”.
                        It not only clean but as well as it gives you the option for manual entries.
                        Application provide you the analysis based on the user input data for the cleaning.
                            The analysis comes in form of PPT.
                        </p>
                    <div className="contact_details">
                        <div className="flex-w size1 p-b-47">
                            <div className="txt1 p-r-25">
                                <span><i className="fa fa-map-marker" style={{ "font-size": "15px" }}></i></span>
                            </div>

                            <div className="flex-col size2">
                                <span className="txt1 p-b-20">
                                    Address
                                    </span>

                                <span className="txt2">
                                    409, Neptune Flying Colours, LBS Cross Road,
                                    Near Mulund Checknaka, Mulund (West), Mumbai-400080
                                    </span>
                            </div>
                        </div>

                        <div className="dis-flex size1 p-b-47">
                            <div className="txt1 p-r-25">
                                <span><i className="fa fa-phone" style={{ "font-size": "15px" }}></i></span>
                            </div>

                            <div className="flex-col size2">
                                <span className="txt1 p-b-20">
                                    Lets Talk
                                    </span>

                                <span className="txt3">
                                    +91 9653698801
                                    </span>
                            </div>
                        </div>

                        <div className="dis-flex size1 p-b-47">
                            <div className="txt1 p-r-25">
                                <span><i className="fa fa-envelope" style={{ "font-size": "15px" }}></i></span>
                            </div>

                            <div className="flex-col size2">
                                <span className="txt1 p-b-20">
                                    General Support
                                    </span>

                                <span className="txt3">
                                    associate@logisticsnow.in
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Old Template code ends here */}

                {/* Upgraded Template Code starts here */}
                {/* <div className='jumbotron'>
                    <center id="form_header">Data Cleaning Metadata Form</center>
                </div>
                <div id="logoutContainer">
                    <button className="btn btn-danger" onClick={e => firebase.logout()}>Logout</button>
                </div> */}
                <div align="center" className="container" style={{ marginTop: '3%', marginLeft: '10%', marginRight: '2%', overflowY: 'hidden', overflowX: 'hidden' }} >
                    <div className="row">
                        {/* <ToastContainer /> */}
                        <div className="col-md-5 col-lg-5 col-sm-12">

                            {
                                (this.state.userLoader) ? (
                                    <div>
                                        <div className="text-center">
                                            <img title="unDraw" alt="unDraw" style={{ marginTop: '10%', marginLeft: '15% !important' }} width="80%" src={formImage} />
                                        </div>
                                        <center>
                                            <h2 id="info">
                                                Uploading Details
                                            </h2>
                                        </center>
                                        <div align="center" className="userLoaderContainer">
                                            <img style={{ width: '50%' }} src={userLoaderGIF} />
                                        </div>
                                    </div>
                                ) : (
                                        <div>
                                            <p>
                                                <img title="unDraw" alt="unDraw" style={{ marginTop: '10%' }} width="80%" src={formImage} />
                                            </p>
                                            <center>
                                                <h2 id="info">
                                                    Fill up details to proceed!
                                                </h2>
                                            </center><br />
                                            <label style={{ float: 'left' }}>Comment:</label>
                                            <textarea className="form-control" rows="10" placeholder="Enter comment if any" columns="10" name="comment" onChange={this.changeHandler} />
                                        </div>
                                    )
                            }

                        </div>
                        <div id="formFirst" className="col-md-7 col-lg-7 col-sm-12" >

                            <div className="row" style={{ marginTop: '2%' }}>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Company:</label>
                                        <input required className="form-control" type="text" name="company" id="company" onChange={this.changeHandler} placeholder="Please enter company name" />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Sector:</label>
                                        <select required name="sector" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT SECTOR --</option>
                                            {
                                                sectors.map(s => <option value={s}>{s}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '1%' }}>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Country:</label>
                                        <select required id="country" name="country" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT COUNTRY --</option>
                                            <option value="INDIA"> India </option>
                                            <option value="AUSTRALIA"> Australia </option>
                                            <option value="CHINA"> China </option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Currency:</label>
                                        <select required id="currency" name="currency" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT CURRENCY --</option>
                                            <option value="INR"> INR </option>
                                            <option value="AUD"> Australian Dollar </option>
                                            <option value="CNY">Chinese Yuan</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '1%' }}>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Mode of Transportation:</label>
                                        <select required id="trans" name="transportation" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT MODE --</option>
                                            <option value="01"> Road </option>
                                            <option value="02"> Rail </option>
                                            <option value="03"> Sea </option>
                                            <option value="04"> Multi-modal </option>
                                            <option value="05"> Air </option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Type of Data Cycle:</label>
                                        <select required id="data_cycle" name="data_cycle" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT DATA CYCLE --</option>
                                            <option value="AD"> Annual </option>
                                            <option value="HD"> Half yearly </option>
                                            <option value="QD"> Quarterly </option>
                                            <option value="MD"> Monthly </option>
                                            <option value="DD"> Daily Dispatch </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '1%' }}>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Type of Data:</label>
                                        <select id="data_type" name="data_type" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT DATA TYPE --</option>
                                            <option value="Primary"> Primary </option>
                                            <option value="Secondary"> Secondary </option>
                                            <option value="Last Mile Transportation">Last Mile Transportation</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Type of Cargo:</label>
                                        <select required id="cargo_type" name="cargo_type" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT CARGO TYPE --</option>
                                            <option value="Reefer"> Reefer </option>
                                            <option value="Ambient"> Ambient </option>
                                            <option value="Temprature Controlled"> Temperature Controlled </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: '1%' }}>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Date:</label>
                                        <select required name="date" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT DATE --</option>
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                            <option value="13">13</option>
                                            <option value="14">14</option>
                                            <option value="15">15</option>
                                            <option value="16">16</option>
                                            <option value="17">17</option>
                                            <option value="18">18</option>
                                            <option value="19">19</option>
                                            <option value="20">20</option>
                                            <option value="21">21</option>
                                            <option value="22">22</option>
                                            <option value="23">23</option>
                                            <option value="24">24</option>
                                            <option value="25">25</option>
                                            <option value="26">26</option>
                                            <option value="27">27</option>
                                            <option value="28">28</option>
                                            <option value="29">29</option>
                                            <option value="30">30</option>
                                            <option value="31">31</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Month:</label>
                                        <select required name="month" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT MONTH --</option>
                                            <option value="01">January</option>
                                            <option value="02">February</option>
                                            <option value="03">March</option>
                                            <option value="04">April</option>
                                            <option value="05">May</option>
                                            <option value="06">June</option>
                                            <option value="07">July</option>
                                            <option value="08">August</option>
                                            <option value="09">September</option>
                                            <option value="10">October</option>
                                            <option value="11">November</option>
                                            <option value="12">December</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Year:</label>
                                        <select required id="year" name="year" style={{ height: '35px' }} className="form-control" onChange={this.changeHandler}>
                                            <option disabled selected>-- SELECT YEAR --</option>
                                            {
                                                year.map(d => <option value={d}>{d}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>



                            <div className="row" style={{ marginTop: '1%' }}>

                                <div className="col-4" style={{ textAlign: 'left' }}>
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Volume Present:</label><br />
                                        <div style={{ width: '30%' }}>
                                            <span className="radio_input">
                                                <input required style={{ textAlign: 'left', marginLeft: '0', width: 'fit-content' }} name="volume_present" onChange={this.volumeChangeHandler} type="radio" value="yes" checked={this.state.volume_present === 'yes'} />
                                            </span>
                                            <label style={{ marginLeft: '30%' }}>Yes</label>
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <span className="radio_input">
                                                <input required style={{ textAlign: 'left', marginLeft: '0', width: 'fit-content' }} name="volume_present" onChange={this.volumeChangeHandler} type="radio" value="no" checked={this.state.volume_present === 'no'} />
                                            </span>
                                            <label style={{ marginLeft: '30%' }}>No</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4" style={{ textAlign: 'left' }}>
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Rate Present:</label><br />
                                        <div style={{ width: '30%' }}>
                                            <span className="radio_input">
                                                <input required style={{ textAlign: 'left', marginLeft: '0', width: 'fit-content' }} name="rate_present" onChange={this.rateChangeHandler} type="radio" value="yes" checked={this.state.rate_present === 'yes'} />
                                            </span>
                                            <label style={{ marginLeft: '30%' }}>Yes</label>
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <span className="radio_input">
                                                <input required style={{ textAlign: 'left', marginLeft: '0', width: 'fit-content' }} name="rate_present" onChange={this.rateChangeHandler} type="radio" value="no" checked={this.state.rate_present === 'no'} />
                                            </span>
                                            <label style={{ marginLeft: '30%' }}>No</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4" style={{ textAlign: 'left' }}>
                                    <div className="form-group">
                                        <label style={{ float: 'left' }}>Spend Present:</label><br />
                                        <div style={{ width: '30%' }}>
                                            <span className="radio_input">
                                                <input required style={{ textAlign: 'left', marginLeft: '0', width: 'fit-content' }} name="spend_present" onChange={this.spendChangeHandler} type="radio" value="yes" checked={this.state.spend_present === 'yes'} />
                                            </span>
                                            <label style={{ marginLeft: '30%' }}>Yes</label>
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <span className="radio_input">
                                                <input required style={{ textAlign: 'left', marginLeft: '0', width: 'fit-content' }} name="spend_present" onChange={this.spendChangeHandler} type="radio" value="no" checked={this.state.spend_present === 'no'} />
                                            </span>
                                            <label style={{ marginLeft: '30%' }}>No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <button align="center" style={{ width: '15%' }} onClick={this.submitHandler} className="btn btn-primary">Submit</button>
                            </div>
                            <hr />
                            <p align="center">
                                <b> If you already cleaned your dataset: </b>
                                <a style={{ "cursor": "pointer", "color": "red" }} onClick={this.goToSummary}> Click here! </a>
                            </p>
                        </div>
                    </div>
                </div>
                {/* New Template Code ends here */}
            </div>
        )
    }
}

export default UserDetails
